<div
  class="dialoghead"
  *ngIf="cookieData?.userinfo?.has_betoparedes_access === 1"
>
  <h1 class="mat-mdc-dialog-title">Success !!</h1>
  <mat-dialog-content>
    <p>
      Looks like you haven’t booked your Gameplan Call yet — let’s get you scheduled! <br />
    </p>
    <div class="mat-mdc-dialog-actions">
      <button mat-button (click)="goToCalender('no')">
        Book a Gameplan Call
      </button>
    </div>
  </mat-dialog-content>
</div>


